/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx, keyframes } from "@emotion/react";
import React from "react";

const summarySkeletonShimmer = keyframes`
  100% {
    transform: translateX(100%);
  }
`;

export const TicketSalesByOrderDateDashboardSkeleton: React.FC = () => {
  return (
    <section css={commonStyles.section}>
      <div css={commonStyles.header}>
        <h2 css={commonStyles.title}>日別販売数（券種別）</h2>
        <p css={commonStyles.subtitle}>支払日ごとの販売数</p>
      </div>

      <div
        css={commonStyles.chartArea}
        aria-busy="true"
        aria-label="グラフを読み込み中"
      >
        <div css={styles.skeleton} />
      </div>
    </section>
  );
};

const styles = {
  skeleton: css`
    position: relative;
    display: block;
    height: 100%;
    overflow: hidden;
    background: #263544;
    border-radius: 8px;
    &::after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: linear-gradient(
        90deg,
        rgb(255 255 255 / 0%) 0%,
        rgb(255 255 255 / 10%) 50%,
        rgb(255 255 255 / 0%) 100%
      );
      animation: ${summarySkeletonShimmer} 1400ms ease-in-out infinite;
      transform: translateX(-100%);
    }
    @media (prefers-reduced-motion: reduce) {
      &::after {
        animation: none;
        transform: translateX(0);
      }
    }
  `,
};

export const commonStyles = {
  section: css`
    width: 100%;
    padding: 14px 16px 18px;
    background: #1b2734;
    border: 1px solid #2e3d4c;
    border-radius: 10px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.22);
  `,
  header: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin: 0 0 8px;
  `,
  title: css`
    color: #ffffff;
    font-size: 14.5px;
    font-weight: 700;
    letter-spacing: 0.4px;
  `,
  subtitle: css`
    margin: 5px 0px 12px;
    font-size: 12px;
    color: #8b96a2;
    letter-spacing: 0.2px;
  `,
  chartArea: css`
    width: 100%;
    height: 294px;
  `,
};
